import { cn } from "@/core/helpers/cn";
import formatPrice from "@/core/helpers/formatPrice";
import { CashIcon } from "@/shared/icons";

export function BankBranchCashBalance({
  balance,
  className,
}: {
  balance: number;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center justify-between", className)}>
      <div className="flex items-center gap-2">
        <CashIcon className="size-5 text-sbank" />
        <div className="text-15 font-normal text-white">Наличные средства:</div>
      </div>

      <div className="text-15 font-medium text-sbank">{formatPrice(balance)} ₽</div>
    </div>
  );
}
